/* eslint-disable */
import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { API_URL } from "../../api";
import RedStar from "../common/RedStar";

export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [code, setCode] = useState("");
  const [accountingTypes, setAccountingTypes] = useState("");
  const [headingList, setHeadingList] = useState([]);
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [accType, setAccType] = useState([]);
  const [amount, setAmount] = useState("");
  const [generalFlag, setGeneralFlag] = useState(true);
  const [relatedCurrency, setRelatedCurrency] = useState("");
  const [flag, setFlag] = useState(false);
  const [natureType, setNautureType] = useState("Credit");
  const [type, setType] = useState("Cash");
  const [currencies, setCurrencies] = useState([]);

  const [errors, setErrors] = useState({
    code: "",
    subHeading: "",
    accountingTypes: "",
    heading: "",
    amount: "",
    relatedCurrency: "",
    natureType: "",
  });

  const AccountCreate = () => {
    const require = {};
    if (!code) {
      require.code = "Account Code is required";
    }
    if (!subHeading) {
      require.subHeading = "Sub Heading is required";
    }
    if (!accountingTypes) {
      require.accountingTypes = "Accounting Type is required";
    }
    if (!heading) {
      require.heading = "Heading is required";
    }
    if (!amount) {
      require.amount = "Balance is required";
    }
    if (!relatedCurrency) {
      require.relatedCurrency = "Currency is required";
    }
    if (!natureType) {
      require.natureType = "AccountNature Type is required";
    }
    if (!type) {
      require.type = "Type is required";
    }

    if (Object.keys(require).length > 0) {
      setErrors(require);
      return require;
    }

    setErrors({
      code: "",
      subHeading: "",
      accountingTypes: "",
      heading: "",
      amount: "",
      relatedCurrency: "",
      natureType: "",
      type: "",
    });

    const currencyCode = currencies.find(
      (item) => item._id === relatedCurrency,
    ).code;

    const data = {
      code: code,
      name: subHeading,
      relatedType: accountingTypes,
      relatedHeader: heading,
      subHeader: subHeading,
      amount: amount,
      openingBalance: amount,
      generalFlag: generalFlag,
      relatedCurrency: currencyCode,
      relatedCurrencyId: relatedCurrency,
      carryForWork: false,
      accountNature: natureType,
      type,
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .post("accounting-list", data, config)
      .then(function (response) {
        // alert("success");
        Swal.fire({
          title: "Successful!",
          text: "You Created Account Data!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
        props.setAccountLists([...props.accountLists, response.data.data]);

        // props.setAccountLists([...props.accountLists, response.data.list])
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Error",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
    props.setOpen(false);
  };

  const handleHeading = async (event) => {
    setHeading(event);
    console.log(heading, headingList);
  };

  const handleAccountHeader = async (value) => {
    setAccountingTypes(value);
    if (value === "") {
      setFlag(false);
      setHeadingList([]);
      return;
    }

    const res = await api.get(`account-headers/related/${value}`);
    console.log(res.data.data, "res.data.data");
    setHeadingList(res.data.data);
    setFlag(true);
    console.log(headingList, "heading");
  };
  useEffect(() => {
    const getAccountingType = async () => {
      try {
        const res = await api.get("account-types");
        setAccType(res.data.list);
      } catch (err) {}
    };
    const getCurrencies = async () => {
      try {
        const res = await api.get("currencies/filter-options");
        setCurrencies(res.data.data);
      } catch (err) {}
    };

    getAccountingType();
    getCurrencies();
  }, []);

  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle>
          <div className="modal-header bg-info">
            <h4 className="modal-title">Add New Accounting</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          {/* @csrf */}
          <div class="modal-body">
            <div class="form-group">
              <label for="name">
                Account Code <RedStar />
              </label>
              <input
                type="text"
                class="form-control border border-info"
                name="acc_code"
                id="acc_code"
                placeholder="eg. 123456"
                onChange={(e) => setCode(e.target.value)}
              />
              {errors?.code && (
                <div className="text-danger">{errors?.code}</div>
              )}
            </div>

            <div class="form-group">
              <label for="name">
                Account Type <RedStar />
              </label>
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => handleAccountHeader(e.target.value)}
              >
                <option value="">Choose Account Type</option>
                {accType.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {errors?.accountingTypes && (
                <div className="text-danger">{errors?.accountingTypes}</div>
              )}
            </div>
            {flag ? (
              <div class="form-group">
                <label for="name">
                  Heading <RedStar />
                </label>
                <select
                  class="custom-select border-info"
                  name="account_type_id"
                  onChange={(e) => handleHeading(e.target.value)}
                >
                  <option>Choose Heading Account</option>
                  {headingList.map((option) => (
                    <option value={option._id}>{option.name}</option>
                  ))}
                </select>
                {errors?.heading && (
                  <div className="text-danger">{errors?.heading}</div>
                )}
              </div>
            ) : null}
            <div class="form-group">
              <label for="name">
                Sub Heading <RedStar />
              </label>

              <input
                type="text"
                name="sub_head"
                className="form-control border-info"
                id=""
                placeholder="Enter Your Account Name"
                onChange={(e) => setSubHeading(e.target.value)}
              />
              {errors?.subHeading && (
                <div className="text-danger">{errors?.subHeading}</div>
              )}
            </div>

            <div class="form-group">
              <label for="name">
                Balance <RedStar />
              </label>
              <input
                type="number"
                class="form-control border-info"
                name="balance"
                placeholder="10000"
                defaultValue={0}
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setAmount(e.target.value)}
              />
              {errors?.amount && (
                <div className="text-danger">{errors?.amount}</div>
              )}
            </div>
            <div className="form-group mt-3">
              <label>
                Currency <RedStar />
              </label>

              <select
                className="form-control"
                name="bank_acc"
                id="bank_acc"
                onChange={(e) => setRelatedCurrency(e.target.value)}
                value={relatedCurrency}
              >
                <option hidden>Select Currency</option>
                {currencies.length > 0 &&
                  currencies.map((currency) => (
                    <option value={currency?._id}>{currency?.code}</option>
                  ))}
              </select>

              {errors?.relatedCurrency && (
                <div className="text-danger">{errors?.relatedCurrency}</div>
              )}
            </div>
            {/* <div class="form-group">
              <label for="name">
                Currency <RedStar />
              </label>
              <input
                type="text"
                class="form-control border-info"
                name="releatedCurrency"
                placeholder="MMK"
                onChange={(e) => setRelatedCurrency(e.target.value)}
              />
              {errors?.relatedCurrency && (
                <div className="text-danger">{errors?.relatedCurrency}</div>
              )}
            </div> */}
            <div className="form-group mt-3">
              <label>
                Acount Nature <RedStar />
              </label>

              <select
                className="form-control"
                name="bank_acc"
                id="bank_acc"
                onChange={(e) => setNautureType(e.target.value)}
                value={natureType}
              >
                <option value="Credit">Credit</option>
                <option value="Debit">Debit</option>
              </select>
              {errors?.natureType && (
                <div className="text-danger">{errors?.natureType}</div>
              )}
            </div>
            <div className="form-group mt-3">
              <label>
                Type <RedStar />
              </label>

              <select
                className="form-control"
                name="bank_acc"
                id="bank_acc"
                onChange={(e) => setType(e.target.value)}
                value={type}
              >
                <option value="Cash">Cash</option>
                <option value="Bank">Bank</option>
              </select>
              {errors?.type && (
                <div className="text-danger">{errors?.type}</div>
              )}
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              onClick={props.close}
            >
              Close
            </button>
            <Button
              type="submit"
              class="btn btn-primary"
              onClick={AccountCreate}
            >
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
